import * as React from 'react';
import { memo } from "react";
import type { PageData } from "../../js/data/pageData.ts";
import { AssetMode } from "../../js/enums.ts";
import { getImgUrl } from "../../js/mediaLibrary/assetUtils.ts";

type Props = React.ComponentPropsWithoutRef<"div"> & {
	item: PageData
}

function PageBox({item, ...otherProps}: Props) {

	return (<>
		<div className="flex flex-col h-full overflow-hidden">
			{item?.cover && <img
				src={item?.cover && getImgUrl(AssetMode.Thumb, item.coverId, item.cover.filename, 443, 250)}
				alt=""
				width={443}
				height={250}
				className="w-full rounded-3xl"
			/>}
			<div className="flex flex-col h-full py-8 items-start">
				<h4 className="leading-snug my-4 md:mb-12">{item.title}</h4>
				{item.blurb && <p className="mb-8 md:mb-12">{item.blurb}</p>}
				<div className="flex-grow"/>
				<a href="/contact-us" className="button white" title={item.title}>ENQUIRE</a>
			</div>
		</div>
	</>);
};

export default memo(PageBox);
